import {Feature} from '../../features/feature.model';
import {ProductRelatedFeatureValue} from './product-related-feature-value';

export class ProductRelatedFeature {
  constructor(public feature: Feature, public items: ProductRelatedFeatureValue[]) {
  }
}
